import { useMount } from 'react-use';

import {
  getLocalSettings,
  updateSettings,
} from 'components/settings/api/personal';
import { useServerStorage } from 'utils/useServerStorage';

/**
 * Migrates favorite agent IDs from localStorage and the old user-storage key
 * (`favouriteTeamMemberIds`) to the new key (`favoriteAgentIds`). Runs once on
 * mount. If user-storage already has the new key, skips migration.
 *
 * TODO: CORE-1405 — Remove this migration after rollout is complete.
 */
export const useFavoriteAgentsMigration = (): void => {
  const storage = useServerStorage('user');

  useMount(() => {
    if (storage.data.team?.favoriteAgentIds !== undefined) {
      return;
    }

    // Migrate from old user-storage key
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const oldStorageFavorites = (storage.data.team as any)
      ?.favouriteTeamMemberIds as unknown;

    if (Array.isArray(oldStorageFavorites) && oldStorageFavorites.length > 0) {
      storage.set({
        team: (draft) => {
          draft.favoriteAgentIds = oldStorageFavorites as string[];
        },
      });
      return;
    }

    // Migrate from localStorage
    const localSettings = getLocalSettings();
    const localFavorites: unknown = localSettings?.favouriteTeamMemberIds;

    if (!Array.isArray(localFavorites) || localFavorites.length === 0) {
      return;
    }

    storage.set({
      team: (draft) => {
        draft.favoriteAgentIds = localFavorites as string[];
      },
    });

    updateSettings({ key: 'favouriteTeamMemberIds', value: undefined });
  });
};
